<template>
    <el-form
        ref="formRef"
        style="max-width: 600px"
        :model="dataForm"
        :rules="rules"
        :disabled="loading"
        label-width="auto"
        v-loading="loading"
        class="center-form"
    >

        <el-form-item
            :label="i18n.tkey('lang_title')"
            prop="jobtitle"
        >
            <el-input
                v-model="dataForm.jobtitle"
                type="text"
                autocomplete="off"
                maxlength="150"
                show-word-limit
            />
        </el-form-item>

        <el-form-item
            :label="i18n.tkey('lang_title_en')"
            prop="shipmentaddress"
        >
            <el-input
                v-model="dataForm.shipmentaddress"
                type="text"
                autocomplete="off"
                maxlength="150"
                show-word-limit
            />
        </el-form-item>

        <el-form-item
            :label="i18n.tkey('lang_chinese_remark')"
            prop="addinfo1"
        >
            <el-input
                v-model="dataForm.addinfo1"
                type="text"
                autocomplete="off"
                maxlength="150"
                show-word-limit
            />
        </el-form-item>

        <el-form-item
            :label="i18n.tkey('lang_english_remark')"
            prop="description2"
        >
            <el-input
                v-model="dataForm.shipmentaddresscn"
                type="text"
                autocomplete="off"
                maxlength="150"
                show-word-limit
            />
        </el-form-item>

        <el-form-item
            :label="i18n.tkey('lang_start_date')"
            prop="jstartdate"
        >
            <el-input
                v-model="dataForm.jstartdate"
                type="date"
                autocomplete="off"
            />
        </el-form-item>

        <el-form-item
            :label="i18n.tkey('lang_end_date')"
            prop="jenddate"
        >
            <el-input
                v-model="dataForm.jenddate"
                type="date"
                autocomplete="off"
            />
        </el-form-item>

        <el-form-item
            :label="i18n.tkey('lang_area_text')"
            prop="district1"
        >
            <el-select
                v-model="dataForm.district1"
                :placeholder="i18n.tkey('lang_select_pls')"
                size="large"
                style=""
                @change=""
            >
                <el-option
                    v-for="(item, i) in counrtyOptions"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                />
            </el-select>
        </el-form-item>

        <el-form-item
            :label="i18n.tkey('lang_youtube_video_url')"
            prop="orderreplyremark"
        >
            <el-input
                v-model="dataForm.orderreplyremark"
                type="text"
                autocomplete="off"
                maxlength="150"
                show-word-limit
            />
        </el-form-item>

        <el-form-item
            :label="i18n.tkey('lang_red_url')"
            prop="orderrefno"
        >
            <el-input
                v-model="dataForm.orderrefno"
                type="text"
                autocomplete="off"
                maxlength="150"
                show-word-limit
            />
        </el-form-item>

        <el-form-item
            :label="i18n.tkey('lang_facebook_url')"
            prop="ordertorefno"
        >
            <el-input
                v-model="dataForm.ordertorefno"
                type="text"
                autocomplete="off"
                maxlength="150"
                show-word-limit
            />
        </el-form-item>

        <el-form-item
            :label="i18n.tkey('lang_titok_url')"
            prop="orderref"
        >
            <el-input
                v-model="dataForm.orderref"
                type="text"
                autocomplete="off"
                maxlength="150"
                show-word-limit
            />
        </el-form-item>

        <el-form-item
            :label="i18n.tkey('lang_video_cover')"
            prop="addinfo5"
        >
            <UploadImg
                v-model="dataForm.addinfo5"
                :useBtn="false"
                :sizeLimit="2048"
                :width="320"
                :height="180"
            />
        </el-form-item>

        <el-form-item>
            <div class="submit-box">
                <el-button type="primary" @click="submitForm(formRef)" v-if="null == editObj" tkey="提交">{{i18n.tkey("lang_submit")}}</el-button>
                <el-button type="primary" @click="submitForm(formRef)" v-if="null != editObj" tkey="保存">{{i18n.tkey("lang_save")}}</el-button>
                <!--            <el-button @click="resetForm(formRef)">Reset</el-button>-->
            </div>
        </el-form-item>
    </el-form>
</template>

<script setup>

import {inject, reactive, ref, onBeforeMount, toRef} from "vue";
import UploadImg from "@/components/shopopee/form/uploadImg.vue";
import {countryList} from "@/util/countrycode";
import myUtil from "@/util/util";
import {useUserinfo} from "@/stores/userinfo";
import jobArrangementRecordApi from "@/request/jobArrangementRecordApi";

const props = defineProps(["editObj"])
const emits = defineEmits(["save-complete"])

const userInfoRef = toRef(useUserinfo())
const i18n = inject("i18n")
const formRef = ref(null)

const loading = ref(false)
const cols = ref(24)

const shopCompany = ref({})
const { getShopCompanyObj } = inject('shopControlFunc', { getShopCompanyObj: () => { return companyInfoRef.value } })

const counrtyOptions = ref([])

const rules = reactive({
    jobtitle: [
        { required: true, message: i18n.tkey("lang_enter_complete") },
    ],
    jstartdate: [
        { required: true, message: i18n.tkey("lang_enter_complete") },
    ],
    jenddate: [
        { required: true, message: i18n.tkey("lang_enter_complete") },
    ],
    district1: [
        { required: true, message: i18n.tkey("lang_enter_complete") },
    ],
    orderreplyremark: [
        { required: true, message: i18n.tkey("lang_enter_complete") },
    ],
    // addinfo5: [
    //     { required: true, message: i18n.tkey("lang_enter_complete") },
    // ],
})

const dataForm = reactive({
    addinfo1: null,  //描述
    addinfo2: null,  //视频链接
    addinfo3: null,  //视频文件路径
    addinfo5: null,  //封面图片路径
    companycode: null,  //公司代码
    district1: null,  //地区代码
    jatype: null,  //类别
    jenddate: null,  //有效期截止日期
    jobtitle: null,  //标题
    jstartdate: null,  //有效期开始日期
    orderactionremark: null,  //3dshop链接
    ordermember: null,  //展台链接
    ordermembergroup: null,  //名片链接
    orderref: null,  //tiktok链接
    orderrefno: null,  //小红书链接
    orderreplyremark: null,  //youtube视频链接
    ordertorefno: null,  //facebook链接
    ownerfinished: null,  //状态 -1正常 0隐藏
    shipmentaddress: null,  //英文标题
    shipmentaddresscn: null,  //英文描述
    updatedid: null,  //类别id
})

const submitForm = (formEl) => {
    if (!formEl) return
    formEl.validate((valid) => {
        if (valid) {
            if (myUtil.isEmpty(dataForm.addinfo5) && myUtil.isNotEmpty(dataForm.orderreplyremark)){
                dataForm.addinfo5 = myUtil.generateYoutubeCoverByUrl(dataForm.orderreplyremark)
            }

            if (null == props.editObj){
                submitData()
            }else{
                updateData()
            }

        }
    })
}

function submitData() {
    loading.value = true

    const request = jobArrangementRecordApi.insertRecord
    const params = request.getParams()

    params.addinfo1 = dataForm.addinfo1
    params.addinfo2 = dataForm.orderreplyremark
    params.addinfo5 = dataForm.addinfo5
    params.companycode = shopCompany.value.companycode
    params.district1 = dataForm.district1
    params.jatype = 0
    params.jobtitle = dataForm.jobtitle
    params.jstartdate = dataForm.jstartdate.replaceAll("-", "/")
    params.jenddate = dataForm.jenddate.replaceAll("-", "/")
    params.orderref = dataForm.orderref
    params.orderrefno = dataForm.orderrefno
    params.orderreplyremark = dataForm.orderreplyremark
    params.ordertorefno = dataForm.ordertorefno
    params.ownerfinished = -1
    params.shipmentaddress = dataForm.shipmentaddress
    params.shipmentaddresscn = dataForm.shipmentaddresscn
    params.updatedid = dataForm.updatedid

    request.send(params, (res) => {
        loading.value = false

        if (res.code == 200){
            myUtil.alertSuccess(i18n.tkey("lang_save_success"))
            emits("save-complete")
        }else{
            myUtil.alertError(res.msg)
        }
    })
}

function updateData(){
    loading.value = true

    const request = jobArrangementRecordApi.updateRecord
    const params = request.getParams()

    Object.assign(params, props.editObj)

    params.addinfo1 = dataForm.addinfo1
    params.addinfo2 = dataForm.orderreplyremark
    params.addinfo5 = dataForm.addinfo5
    params.companycode = shopCompany.value.companycode
    params.district1 = dataForm.district1
    params.jatype = 0
    params.jobtitle = dataForm.jobtitle
    params.jstartdate = dataForm.jstartdate.replaceAll("-", "/")
    params.jenddate = dataForm.jenddate.replaceAll("-", "/")
    params.orderref = dataForm.orderref
    params.orderrefno = dataForm.orderrefno
    params.orderreplyremark = dataForm.orderreplyremark
    params.ordertorefno = dataForm.ordertorefno
    params.ownerfinished = -1
    params.shipmentaddress = dataForm.shipmentaddress
    params.shipmentaddresscn = dataForm.shipmentaddresscn
    params.updatedid = dataForm.updatedid

    request.send(params, (res) => {
        loading.value = false

        if (res.code == 200){
            myUtil.alertSuccess(i18n.tkey("lang_save_success"))
            emits("save-complete")
        }else{
            myUtil.alertError(res.msg)
        }
    })
}

function fillCountryOptions(){
    const list = []

    countryList.forEach((v) => {
        let name = v.en

        if (userInfoRef.value.lang === "zh" || userInfoRef.value.lang === "szh"){
            name = v.zh
        }

        list.push({
            code: v.countrycode,
            name: name
        })
    })

    counrtyOptions.value = list
}

function fillEditData(){
    dataForm.addinfo1 = props.editObj.addinfo1
    dataForm.addinfo5 = props.editObj.addinfo5
    dataForm.companycode = props.editObj.companycode
    dataForm.district1 = props.editObj.district1
    dataForm.jobtitle = props.editObj.jobtitle
    dataForm.jstartdate = props.editObj.jstartdate.replaceAll("/", "-")
    dataForm.jenddate = props.editObj.jenddate.replaceAll("/", "-")
    dataForm.orderref = props.editObj.orderref
    dataForm.orderrefno = props.editObj.orderrefno
    dataForm.orderreplyremark = props.editObj.orderreplyremark
    dataForm.ordertorefno = props.editObj.ordertorefno
    dataForm.shipmentaddress = props.editObj.shipmentaddress
    dataForm.shipmentaddresscn = props.editObj.shipmentaddresscn
    dataForm.updatedid = props.editObj.updatedid
}

onBeforeMount(() => {
    if (!myUtil.isMobile()){
        cols.value = 12
    }

    shopCompany.value = getShopCompanyObj()
    fillCountryOptions()

    if (null != props.editObj){
        fillEditData()
    }
})

</script>

<style scoped>

.center-form {
    margin: auto;
}

.info-parts {
    margin-bottom: 10px;
}

.submit-box {
    text-align: center;
    margin-top: 12px;
    width: 100%;
}

</style>